import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "pr-3",
    style: _vm.conditionIndicies.length === 0 ? 'overflow-x: auto; overflow-y: visible' : ''
  }, [_c('div', {
    staticClass: "dtwin-rule-conditions my-0"
  }, [_c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', {
    staticClass: "mb-2",
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "width": "140px"
    }
  }, [_vm.conditions.items.length <= 1 ? [_c(VTextField, {
    attrs: {
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": "",
      "readonly": "",
      "disabled": "",
      "value": _vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.operations.when'),
      "label": ""
    }
  })] : [_c(VSelect, {
    staticClass: "logical-operation",
    attrs: {
      "disabled": _vm.disabled,
      "items": _vm.logicalOperators,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": ""
    },
    on: {
      "change": function ($event) {
        return _vm.emitChange();
      }
    },
    model: {
      value: _vm.conditions.type,
      callback: function ($$v) {
        _vm.$set(_vm.conditions, "type", $$v);
      },
      expression: "conditions.type"
    }
  })]], 2), _c('div', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "column"
    }
  }, _vm._l(_vm.conditions.items, function (def, j) {
    return _c('div', {
      key: `condition_item_${j}`,
      staticClass: "mx-2 mb-2",
      staticStyle: {
        "display": "flex",
        "flex-direction": "row",
        "align-items": "center",
        "min-width": "620px"
      }
    }, [!!def.compOperator ? [_c('div', {
      staticClass: "mr-2",
      staticStyle: {
        "display": "flex",
        "width": "150px"
      }
    }, [_c(VSelect, {
      attrs: {
        "disabled": _vm.disabled,
        "items": _vm.rule.properties.stateMetrics,
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "item-text": "key",
        "item-value": "key",
        "hide-details": ""
      },
      on: {
        "change": function ($event) {
          return _vm.$emit('change');
        }
      },
      model: {
        value: def.key,
        callback: function ($$v) {
          _vm.$set(def, "key", $$v);
        },
        expression: "def.key"
      }
    })], 1), _c('div', {
      staticClass: "mx-2",
      staticStyle: {
        "display": "flex"
      }
    }, [_c(VSelect, {
      staticClass: "comparision-operation",
      attrs: {
        "disabled": _vm.disabled,
        "items": _vm.comparitionOperatorsForState(def.key),
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "hide-details": ""
      },
      on: {
        "change": function ($event) {
          return _vm.emitChange();
        }
      },
      model: {
        value: def.compOperator,
        callback: function ($$v) {
          _vm.$set(def, "compOperator", $$v);
        },
        expression: "def.compOperator"
      }
    })], 1), _c('div', {
      staticClass: "mx-2",
      staticStyle: {
        "display": "flex"
      }
    }, [_c(VTextField, {
      attrs: {
        "disabled": _vm.disabled,
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "required": "",
        "hide-details": "",
        "label": ""
      },
      on: {
        "change": function ($event) {
          return _vm.emitChange();
        }
      },
      model: {
        value: def.compValue,
        callback: function ($$v) {
          _vm.$set(def, "compValue", $$v);
        },
        expression: "def.compValue"
      }
    })], 1), _c('div', {
      staticClass: "mx-0",
      staticStyle: {
        "display": "flex"
      }
    }, [!_vm.disabled ? _c(VBtn, {
      class: 'v-btn-x v-btn--rounded bg-rounded-button-' + _vm.color,
      attrs: {
        "color": _vm.color,
        "title": _vm.$i18n_t('Common.delete'),
        "icon": "",
        "info": "",
        "fab": "",
        "text": ""
      },
      on: {
        "click": function ($event) {
          return _vm.removeCondition(j);
        }
      }
    }, [_c(VIcon, {
      attrs: {
        "dark": ""
      }
    }, [_vm._v("fal fa-trash-alt")])], 1) : _vm._e()], 1)] : _c('core-dtwin-rule-edit-conditions', {
      attrs: {
        "disabled": _vm.disabled,
        "rule": _vm.rule,
        "states": _vm.states,
        "templateContext": _vm.templateContext,
        "isCreatedByTemplate": _vm.isCreatedByTemplate,
        "conditionIndicies": _vm.conditionIndicies.concat(j)
      },
      on: {
        "remove": function ($event) {
          return _vm.removeCondition(j);
        },
        "conditions-changed": function ($event) {
          return _vm.emitChange();
        }
      }
    })], 2);
  }), 0)]), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "width": "140px"
    }
  }), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }), _c('div', {
    staticClass: "mx-2 my-0"
  }, [!_vm.disabled ? _c(VBtn, {
    class: 'mr-2 v-btn-x v-btn--rounded bg-rounded-button-' + _vm.color,
    attrs: {
      "color": _vm.color,
      "title": _vm.$i18n_t('Common.addNew'),
      "icon": "",
      "info": "",
      "fab": "",
      "text": ""
    },
    on: {
      "click": _vm.addCondition
    }
  }, [_c(VIcon, {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("fal fa-plus")])], 1) : _vm._e(), !_vm.disabled ? _c(VBtn, {
    class: 'mr-2 v-btn-x v-btn--rounded bg-rounded-button-' + _vm.color,
    attrs: {
      "color": _vm.color,
      "title": _vm.$i18n_t('Common.addNewNested'),
      "icon": "",
      "info": "",
      "fab": "",
      "text": ""
    },
    on: {
      "click": _vm.addOperator
    }
  }, [_c(VIcon, {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("fal fa-function")])], 1) : _vm._e(), !_vm.disabled && _vm.conditionIndicies.length > 0 ? _c(VBtn, {
    class: 'v-btn-x v-btn--rounded bg-rounded-button-' + _vm.color,
    attrs: {
      "color": _vm.color,
      "title": _vm.$i18n_t('Common.delete'),
      "icon": "",
      "info": "",
      "fab": "",
      "text": ""
    },
    on: {
      "click": _vm.removeConditions
    }
  }, [_c(VIcon, {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("fal fa-trash-alt")])], 1) : _vm._e()], 1)])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };